import { ScreenHeader } from "@/components/ui/ScreenHeader";
import { Stack } from "expo-router";

export default function InvitationsLayout() {
  return (
    <Stack screenOptions={{ headerShown: true, header: (props) => <ScreenHeader {...props} /> }} />
  );
}
